import React, { memo } from 'react'
import { FormValidation } from '@rjsf/utils'
import { collapseUnion } from '@feedyou/utils'
import { useDispatch } from 'react-redux'

import { useSettingsPopupState } from '../hooks'
import { CustomFormPopup } from '../CustomFormPopup'
import { runNlpTestThunk } from '../../../features/nlpTester'
import { useNlpModels } from '../../../store/flow'
import { ModalDescriptorForType } from '../../../store/modals'
import { cleanEmptyProperties } from '../../../lib/rjsf'
import { injectModelsToSchema } from '../sharedSchemaFragments/nlpModelsTest/utils/injectModelsToSchema'
import {
  schema,
  uiSchema,
  FormData,
  defaultFormData
} from '../sharedSchemaFragments/nlpModelsTest/constants'

type Props = { modalDescriptor: ModalDescriptorForType<'nlp_models_test'> }

export const NlpModelsTestPopup: React.FC<Props> = memo(({ modalDescriptor }) => {
  const dispatch = useDispatch()
  const allModels = useNlpModels()
  const { formData = '', onFormDataChange } = useSettingsPopupState(() => defaultFormData) as any

  return (
    <CustomFormPopup<FormData>
      formData={cleanEmptyProperties(formData)}
      onChange={onFormDataChange}
      labels={{ buttons: { submit: 'Run test' } }}
      onSubmit={formData => {
        const modelsToUse =
          formData?.testAgainstModels?.mode === 'CHOOSE'
            ? allModels.filter(model =>
                // @ts-ignore bug in collapseUnion - does not handle arrays correctly
                collapseUnion(formData?.testAgainstModels)?.chosenModels?.includes(model.id)
              )
            : allModels

        dispatch(
          runNlpTestThunk({
            input: formData?.testData,
            onlyQueryAgainstExpectedModel: formData?.testAgainstModels?.mode === 'EXPECTED',
            models: modelsToUse
          })
        )
      }}
      schema={injectModelsToSchema(schema, allModels, modalDescriptor.modelId)}
      uiSchema={uiSchema}
      validateSchema={(formData, errors: FormValidation<any>) => {
        if (!formData?.testData?.trim()) {
          errors.testData?.addError(
            'Please enter test cases into the text area in described format.'
          )
        }

        // No idea why I have to do this - `minItems: 1` should take care of it, but it doesn't work
        if (
          formData?.testAgainstModels?.mode === 'CHOOSE' &&
          !formData?.testAgainstModels?.chosenModels?.length
        ) {
          errors.testAgainstModels?.chosenModels?.addError('Please choose at least one model.')
        }

        return errors
      }}
      title="NLP Tester - Enter test cases"
    />
  )
})
